// extracted by mini-css-extract-plugin
export default {"addButton":"app-react-components-buttons-AddButton-module__add-button"};